import React from "react";
import ReactDOM from "react-dom";
const portalElement = typeof document !== 'undefined' ? document.getElementById('overlays') : '';
const Overlay = (props) => {
    const Portal = portalElement ? ReactDOM.createPortal(props.children, portalElement) : React.createElement(React.Fragment, null);
    return (React.createElement(React.Fragment, null, Portal));
};
export default Overlay;
